<template>
    <section class="welcome flow__panel flow__container-fluid">
        <div class="welcome__main">
            <h2 class="welcome__title">
                {{ myResources.title }}
            </h2>
            <app-sponsorship class="welcome__sponsorship" />
            <markdown :content="introText" />
            <div class="welcome__buttons">
                <hh-btn class="welcome__button welcome__button--get-started" :text="myResources.ctaGetStarted" @click="onProceed" />
                <hh-btn class="welcome__button welcome__button--login" :text="commonResources.login" @click="login" />
            </div>
        </div>
    </section>
</template>

<script>

import AppSponsorship from '@/components/app-core/app-sponsorship'
import ResourcesHelper from '@/components/resources-helper'
import Markdown from '@/components/markdown'
import ProgressManager from '@/progress-manager'

export default {
    mixins: [
        ResourcesHelper,
    ],

    computed: {
        /**
         * Return the resources object for this page.
         * @return {WelcomeResources}
         */
        myResources() {
            return this.parseResources('views.welcome')
        },

        /**
         * Return the correct intro text based on type of scheme.
         * @return {string}
         */
        introText() {
            return this.myResources.introText
        },
    },

    methods: {
        /**
         * Handle login button click.
         */
        login() {
            this.$router.push({ name: 'LogIn' })
        },

        /**
         * Handle get started button click.
         */
        onProceed() {
            this.$router.push(ProgressManager.getNext(this.$route.name))
        },
    },

    components: {
        AppSponsorship,
        Markdown,
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
.welcome {
    @include element('main') {
        max-width: 810px;
    }

    @include elements('buttons') {
        margin-top: $wide-gutter * 2;
    }

    @include element('button') {
        display: block;
        width: 150px;
        margin-bottom: $wide-gutter !important;
    }
}

</style>
